import React from 'react';
import { ReportClock, ReportFolder } from '../../assets/images/svgs';
import { CredusText, CredusWrapper } from 'ui';
import styled from 'styled-components';
import ReportCard from './components/ReportCard';
import { ReportStatisticsProps } from './report-models/report.interface';
import moment from 'moment';

type ReportCardProps = {
  text?: string;
  value?: number | string;
  subText?: string | undefined;
  subValue?: number | string;
};

const ReportStatistics = ({
  testDetailReport,
  paramsData,
}: ReportStatisticsProps) => {
  const statisticsArray: ReportCardProps[] = [
    {
      text: 'Total Candidates',
      value: testDetailReport?.totalCandidates || 0,
    },
    {
      text: 'Attendees',
      value: testDetailReport?.attendees,
      subText: 'Absentees',
      subValue: testDetailReport?.absentees || 0,
    },
    {
      text: 'Passed',
      value: testDetailReport?.passed || 0,
      subText: 'Failed',
      subValue: testDetailReport?.failed || 0,
    },
    {
      text: 'Highest score',
      value: testDetailReport?.highestScore || '0%',
      subText: 'Lowest score',
      subValue: testDetailReport?.lowestScore || '0%',
    },
  ];

  return (
    <div>
      <TopWrapper padding="24px" radius="5px  5px 0px 0px" bg="#fff">
        <CredusWrapper display="flex" justify="space-between" align="center">
          <CredusText size="xl" weight="bold">
            {paramsData?.subjectName}
          </CredusText>
          <CredusText size="sm" weight="medium" color="rgba(0, 0, 0, 0.39);">
            {moment(paramsData?.testDate, 'DD/MM/YYYY').format('MMM Do YYYY')}
          </CredusText>
        </CredusWrapper>
        <CredusWrapper
          mt="0.2rem"
          display="flex"
          justify="space-between"
          align="center"
        >
          <CredusText size="sm" weight="medium" color="#828282">
            Category: {paramsData?.categoryId}
          </CredusText>
          <CredusWrapper display="flex" gap="1rem">
            <CredusWrapper
              bg="#F8F8FF"
              radius="8px"
              display="flex"
              align="center"
              gap="8px"
              padding="8px"
            >
              <ReportClock />
              <CredusText size="sm" weight="bold" color="rgba(0, 0, 0, 0.39);">
                1HR
              </CredusText>
            </CredusWrapper>
            <CredusWrapper
              bg="#F8F8FF"
              radius="5px"
              align="center"
              display="flex"
              gap="8px"
              padding="8px"
            >
              <ReportFolder />
              <CredusText size="sm" weight="bold" color="rgba(0, 0, 0, 0.39);">
                100 Marks
              </CredusText>
            </CredusWrapper>
          </CredusWrapper>
        </CredusWrapper>
        <CredusWrapper
          mt="0.2rem"
          display="flex"
          justify="space-between"
          align="center"
        >
          <CredusText size="sm" weight="medium" color="#828282">
            50 Questions
          </CredusText>
        </CredusWrapper>
      </TopWrapper>
      <BottomWrapper
        padding="2.56rem 2.21rem 1.93rem"
        bg="#FAFAFB"
        radius="0px 0px 5px 5px"
        display="flex"
        justify="center"
      >
        <GridWrap>
          {statisticsArray?.map((item: ReportCardProps, i: React.Key) => (
            <ReportCard
              key={i}
              text={item.text}
              value={item.value}
              subText={item.subText}
              subValue={item.subValue}
            />
          ))}
        </GridWrap>
      </BottomWrapper>
    </div>
  );
};

export default ReportStatistics;

const GridWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 3.125rem;
  /* grid-gap: 2.1rem; */
`;

const TopWrapper = styled(CredusWrapper)`
  border-top: 1px solid rgba(224, 222, 247, 0.5);
  border-left: 1px solid rgba(224, 222, 247, 0.5);
  border-right: 1px solid rgba(224, 222, 247, 0.5);
`;
const BottomWrapper = styled(CredusWrapper)`
  border-bottom: 1px solid rgba(224, 222, 247, 0.5);
  border-left: 1px solid rgba(224, 222, 247, 0.5);
  border-right: 1px solid rgba(224, 222, 247, 0.5);
`;
